import { DTFItem } from './packing';

// Sauvegarde locale de la planche (IndexedDB : les data URLs dépassent vite le quota localStorage)
const DB_NAME = 'dtf_v2_state';
const STORE = 'kv';
const KEY = 'items';

const openDb = (): Promise<IDBDatabase> =>
	new Promise((resolve, reject) => {
		const req = indexedDB.open(DB_NAME, 1);
		req.onupgradeneeded = () => req.result.createObjectStore(STORE);
		req.onsuccess = () => resolve(req.result);
		req.onerror = () => reject(req.error);
	});

export const saveItems = async (items: DTFItem[]): Promise<void> => {
	try {
		const db = await openDb();
		await new Promise<void>((resolve, reject) => {
			const tx = db.transaction(STORE, 'readwrite');
			tx.objectStore(STORE).put(items, KEY);
			tx.oncomplete = () => resolve();
			tx.onerror = () => reject(tx.error);
		});
		db.close();
	} catch {
		// stockage indisponible (navigation privée…) : tant pis, pas bloquant
	}
};

export const loadItems = async (): Promise<DTFItem[] | null> => {
	try {
		const db = await openDb();
		const out = await new Promise<DTFItem[] | null>((resolve, reject) => {
			const tx = db.transaction(STORE, 'readonly');
			const req = tx.objectStore(STORE).get(KEY);
			req.onsuccess = () => resolve(Array.isArray(req.result) ? (req.result as DTFItem[]) : null);
			req.onerror = () => reject(req.error);
		});
		db.close();
		return out;
	} catch {
		return null;
	}
};

/** Planches prêtes à commander, lues par /commande-dtfs.html (même origine). */
export interface PendingPlanche {
	name: string;
	/** #223 (ancien flux) : PDF fabriqué dans le navigateur. Absent quand la planche est figée côté serveur (bibliothèque, 15.10.2026). */
	pdf?: ArrayBuffer;
	/** Planche FIGÉE côté serveur : la commande cite cette révision, aucun fichier ne transite */
	board_version_id?: string;
	/** vignette (data URL ≤ 320 px) pour la page de commande et le panier */
	thumb?: string;
	wcm: number;
	hcm: number;
	qty: number;
	index: number;
	/** colle choisie dans l'éditeur (Daniel 09.10.2026) : 'base' coton/polyester, 'anti' polyester sublimé */
	glue?: GlueChoice;
}
export type GlueChoice = 'base' | 'anti';
export interface PendingOrder {
	createdAt: string;
	source: 'editeur-v2';
	planches: PendingPlanche[];
	glue?: GlueChoice;
}
const PENDING_KEY = 'pendingOrder';
export const savePendingOrder = async (order: PendingOrder): Promise<void> => {
	const db = await openDb();
	await new Promise<void>((resolve, reject) => {
		const tx = db.transaction(STORE, 'readwrite');
		tx.objectStore(STORE).put(order, PENDING_KEY);
		tx.oncomplete = () => resolve();
		tx.onerror = () => reject(tx.error);
	});
	db.close();
};
